export default "__VITE_ASSET__Bel2gJZ4__"